import React, { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "@/App";
import { Home, Tag, Store, Clapperboard, UserRound } from "lucide-react";
import { dashboardPath } from "./SiteHeader";

const HIDDEN_PREFIXES = ["/admin", "/seller", "/store/", "/login", "/register", "/forgot-password", "/dashboard", "/wallet", "/referrals", "/profile"];

export const MobileBottomNav = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const hidden = HIDDEN_PREFIXES.some((p) => pathname.startsWith(p));

  useEffect(() => {
    document.body.classList.toggle("has-bottom-nav", !hidden);
  }, [hidden]);

  if (hidden) return null;
  const items = [
    { to: "/", label: "Home", icon: Home, id: "home", end: true },
    { to: "/products", label: "Deals", icon: Tag, id: "deals" },
    { to: "/brands", label: "Brands", icon: Store, id: "brands", center: true },
    { to: "/reels", label: "Reels", icon: Clapperboard, id: "reels" },
    { to: dashboardPath(user), label: user ? "Account" : "Login", icon: UserRound, id: "account" },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-white/90 backdrop-blur-xl border-t border-primary-100 shadow-[0_-8px_30px_rgba(76,29,149,0.12)] pb-[env(safe-area-inset-bottom)]" data-testid="mobile-bottom-nav">
      <div className="grid grid-cols-5 h-16">
        {items.map((it) => (
          <NavLink key={it.id} to={it.to} end={it.end} className="flex flex-col items-center justify-center gap-0.5" data-testid={`bottom-nav-${it.id}`}>
            {({ isActive }) =>
              it.center ? (
                <>
                  <span className={`-mt-7 w-14 h-14 rounded-full flex items-center justify-center border-4 border-white shadow-lg transition-transform ${isActive ? "bg-secondary-500 text-primary-900 scale-105" : "bg-primary-600 text-white"}`}>
                    <it.icon className="w-6 h-6" />
                  </span>
                  <span className={`text-[11px] font-bold ${isActive ? "text-primary-700" : "text-primary-400"}`}>{it.label}</span>
                </>
              ) : (
                <>
                  <span className={`px-4 py-1 rounded-full transition-colors ${isActive ? "bg-primary-100 text-primary-700" : "text-primary-400"}`}>
                    <it.icon className="w-5 h-5" />
                  </span>
                  <span className={`text-[11px] font-bold ${isActive ? "text-primary-700" : "text-primary-400"}`}>{it.label}</span>
                </>
              )
            }
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
